import { Route } from "react-router-dom";
import { NewAuthWrapper } from "../auth";
import { Layout } from "./layout";
import ListProjectsPage from "./pages/ListProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";

const getRoutes = () => {
  return [
    <Route exact path='/ps/:companyId/deal-management'
      render={() => <NewAuthWrapper>
        <Layout contentWide>
          <ListProjectsPage />
        </Layout>
      </NewAuthWrapper>} />,
    <Route exact path='/ps/:companyId/deal-management/projects/:projectId'
      render={() => <NewAuthWrapper>
        <Layout contentWide>
          <ProjectDetailPage />
        </Layout>
      </NewAuthWrapper>} />,
  ]
}

export default getRoutes;

